import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, DialogContentText, Typography } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";

const useStyles = makeStyles(() => ({
  deleteButton: {
    color: "red",
  },
}));

const ConfirmDeleteDialog = ({ open, handleClose, name, handleConfirm }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <Typography>Delete document?</Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete {name}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} className={classes.deleteButton}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
